import React from 'react';
import classNames from 'classnames';
import Tooltip from '../tooltip/tooltip';
export default function () {
  var _this = this;

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(this.props.getClassName('control-docking-plane-button-outer'), {
      'is-disabled': this.isDisabled()
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames('control-docking-plane-button', {
      'plane-docked': this.props.vertical || this.props.horizontal,
      'is-disabled': this.isDisabled()
    }),
    onClick: function onClick() {
      return _this.showPopover();
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    content: this.props.centerHint,
    disabled: !this.props.centerHint,
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-point"
  }))), /*#__PURE__*/React.createElement("div", {
    className: classNames('control-docking-plane-popover', {
      shown: this.state.showPopover,
      hover: this.state.hoverPopover
    }),
    onMouseEnter: function onMouseEnter() {
      return _this.showPopover();
    },
    onMouseLeave: function onMouseLeave() {
      return _this.hidePopover();
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  }), /*#__PURE__*/React.createElement("div", {
    "data-direction": "vertical",
    className: classNames('docking-plane vertical', {
      'plane-docked': this.props.vertical,
      'is-disabled': this.isVerticalDisabled()
    }),
    onClick: function onClick() {
      return _this.onChange('VERTICAL');
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: "vertical-tooltip",
    content: this.props.translateIfNeeded(this.props.hintVertical),
    disabled: !this.props.translateIfNeeded(this.props.hintVertical),
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "vertical-plane",
    className: "docking-point"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  }), /*#__PURE__*/React.createElement("div", {
    "data-direction": "horizontal",
    className: classNames('docking-plane horizontal', {
      'plane-docked': this.props.horizontal,
      'is-disabled': this.isHorizontalDisabled()
    }),
    onClick: function onClick() {
      return _this.onChange('HORIZONTAL');
    }
  }, /*#__PURE__*/React.createElement(Tooltip, {
    dataHook: "horizontal-tooltip",
    content: this.props.translateIfNeeded(this.props.hintHorizontal),
    disabled: !this.props.translateIfNeeded(this.props.hintHorizontal),
    isHint: true,
    alignment: 'TOP'
  }, /*#__PURE__*/React.createElement("div", {
    "data-hook": "horizontal-plane",
    className: "docking-point"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "docking-plane-spacer"
  })));
}